module.exports = __webpack_public_path__ + "static/img/06.bc11a01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhmnq/06.jpg
// module id = t/ik
// module chunks = 1